module.exports = __webpack_public_path__ + "static/913-f441134bbef3c7153b757ea45a9e7589.png";